import React, { useState } from 'react';
import { Form } from '@ant-design/compatible';
import { useQueryClient } from '@tanstack/react-query';

import GenerateCouponValidSuccessModalView from './GenerateCouponValidSuccessModalView';
import { useGenerateCoupon } from './hooks';
import { setTrim } from '../../../../../../lib/common';
import { accountUserActions } from '../../../../../../store/modules/account/user';
import { USER_ACTIONS_NAME } from '../../../../../../constants/service/app/accountUserConstants';
import { accountUserDetailKey } from '../../common/queryKeys';

const GenerateCouponValidSuccessModalContainer = (props) => {
  const { closeModal, validResult, form } = props;
  const queryClient = useQueryClient();

  const [isSendAlimtalk, setIsSendAlimtalk] = useState(false);
  const [memo, setMemo] = useState(null);

  const { generateCoupon } = useGenerateCoupon();

  const handleGenerateCoupon = async () => {
    await generateCoupon({
      userCouponList: validResult.userCouponList,
      isSendAlimtalk,
      memo: setTrim(memo),
      targetAction: {
        name: USER_ACTIONS_NAME,
        ...accountUserActions,
      },
    });

    //유저상세 -> 쿠폰 정보 페이지의 데이터를 재요청
    queryClient.invalidateQueries({
      queryKey: [...accountUserDetailKey, 'couponDetail'],
    });

    closeModal();
  };

  return (
    <GenerateCouponValidSuccessModalView
      form={form}
      closeModal={closeModal}
      validResult={validResult}
      memo={memo}
      setMemo={setMemo}
      isSendAlimtalk={isSendAlimtalk}
      setIsSendAlimtalk={setIsSendAlimtalk}
      onGenerateCoupon={handleGenerateCoupon}
    />
  );
};

export default Form.create()(GenerateCouponValidSuccessModalContainer);
